"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UserProfileType;
(function (UserProfileType) {
    UserProfileType["Admin"] = "admin";
    UserProfileType["Staff"] = "staff";
    UserProfileType["Student"] = "student";
    UserProfileType["Others"] = "others";
})(UserProfileType = exports.UserProfileType || (exports.UserProfileType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW50ZXJmYWNlcy5qcyIsInNvdXJjZVJvb3QiOiIuLyIsInNvdXJjZXMiOlsicGRmL2RhdGEvaW50ZXJmYWNlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQTBDQSxJQUFZLGVBS1g7QUFMRCxXQUFZLGVBQWU7SUFDdkIsa0NBQWUsQ0FBQTtJQUNmLGtDQUFlLENBQUE7SUFDZixzQ0FBbUIsQ0FBQTtJQUNuQixvQ0FBaUIsQ0FBQTtBQUNyQixDQUFDLEVBTFcsZUFBZSxHQUFmLHVCQUFlLEtBQWYsdUJBQWUsUUFLMUIifQ==